import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import PropTypes from "prop-types";
import update from 'immutability-helper';
import {
    Table,
    Segment,
    Breadcrumb,
    Button,
    Input,
    Label,
    Icon,
    Dropdown
} from "semantic-ui-react";
import _ from "lodash";
import accounting from 'accounting';
import qs from "qs";
import Dls from "../../lib";
import {
    fetchSprProducts
} from "../../actions/ecommerce";
import TablePagination from "../utils/tables/TablePagination";
import {api} from "../../api";


class SprProductList extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            routing: {
                params: {
                    page: 1,
                    search: "",
                    shopify: "na",
                    spr: "na"
                },
                path: ""
            }
        };
    }

    componentDidMount() {
        const { params } = this.props.match;
        this.setQueryParamsFromPath(params.params, params.type);
    }

    componentWillReceiveProps(props) {
        const { params } = props.match;
        this.setQueryParamsFromPath(params.params, params.type);
    }

    setQueryParamsFromPath = (path) => {
        if (this.state.routing.path !== path) {
            const params = qs.parse(path);
            this.setState({
                routing: { params, path }
            }, () => {
                this.fetchRecords();
            });
        }
    };

    fetchRecords = () => {
        const {jwt} = this.props;
        const {params} = this.state.routing;
        this.props.fetchSprProducts(jwt, qs.stringify(params)).catch(err => {
            Dls.apiErrorAlert(err);
        });;
    };

    runSearch = () => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    on_page: { $set: 1 }
                })
            }
        }, () => {
            this.routeTo();
        });
    };

    routeTo = () => {
        this.props.history.push(`/settings/ecommerce/products/${qs.stringify(this.state.routing.params)}`);
    }

    goToPage = (page) => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    page: { $set: page }
                })
            }
        }, () => {
            this.routeTo();
        });
    }

    render() {
        const {list} = this.props;
        return (
            <div>
                <div className="row" style={{ marginBottom: "15px" }}>
                    <div className="col-md-8">
                        <Breadcrumb size="huge">
                            <Breadcrumb.Section>
                                SPR Product List
                            </Breadcrumb.Section>
                        </Breadcrumb>
                    </div>
                </div>

                <div className="row" style={{ marginBottom: "15px" }}>
                    <div className="col-md-3">
                        <Dropdown 
                            options={[
                                {value: "na", text: "Filter By SPR Datafeed"},
                                {value: "yes", text: "SPR Imported"},
                                {value: "no", text: "SPR Not Imported"}
                            ]}
                            value={this.state.routing.params.spr}
                            onChange={(e, {value}) => {
                                this.setState({
                                    routing: update(this.state.routing, {
                                        params: {
                                            spr: {$set: value}
                                        }
                                    })
                                })
                            }}
                            fluid selection
                            size="mini"
                        />
                    </div>
                    <div className="col-md-3">
                        <Dropdown 
                            options={[
                                {value: "na", text: "Filter By Shopify Status"},
                                {value: "yes", text: "In Shopify"},
                                {value: "no", text: "Not In Shopify"}
                            ]}
                            value={this.state.routing.params.shopify}
                            onChange={(e, {value}) => {
                                this.setState({
                                    routing: update(this.state.routing, {
                                        params: {
                                            shopify: {$set: value}
                                        }
                                    })
                                })
                            }}
                            fluid selection
                            size="mini"
                        />
                    </div>
                    <div className="col-md-6">
                        <Input
                            placeholder="Search by SKU"
                            size="mini"
                            action
                            onKeyPress={(e) => {
                                if (e.key === "Enter") {
                                    this.routeTo();
                                }
                            }}
                            value={this.state.routing.params.search}
                            onChange={(e, {value}) => {
                                this.setState({
                                    routing: update(this.state.routing, {
                                        params: {
                                            search: {$set: value},
                                            page: {$set: 1}
                                        }
                                    })
                                })
                            }}
                            fluid
                        >
                            <input />
                            <Button
                                icon="filter"
                                onClick={() => {this.routeTo()}}
                                type="button"
                                color="pink"
                            />
                        </Input>
                    </div>

                </div>

                <div className="row">
                    <div className="col-md-12">
                        <Table compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>
                                        SKU
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Name
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        SPR Category
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Cost
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Sell
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        SPR Feed
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Shopify
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {_.isArray(list.data) ? list.data.map((i) => {
                                    return <Table.Row key={i.id}>
                                        <Table.Cell>
                                            <Link to={`/settings/ecommerce/products/${i.id}/edit`}>{i.excel_sku}</Link>
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.excel_name}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.srp_category}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {accounting.formatMoney(i.excel_dls_cost)}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {accounting.formatMoney(i.excel_dls_sell)}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.spr_id > 0 ? "Yes" : "No"}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.shopify_id > 0 ? "Yes" : "No"}
                                        </Table.Cell>
                                    </Table.Row>
                                }) : null}
                            </Table.Body>
                        </Table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12" style={{marginTop: '5px'}}>
                        <TablePagination 
                            goToPage={(page) => {this.goToPage(page);}}
                            on_page={list.current_page ? list.current_page : 1} 
                            total_records={list.total ? list.total : 1} 
                            per_page={list.per_page ? list.per_page : 1} />
                    </div>
                </div>
            </div>
        );
    }
}

SprProductList.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    list: PropTypes.object.isRequired,
    jwt: PropTypes.string.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        list: state.ecommerce.sprProducts
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchSprProducts
    }, dispatch);
}

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(SprProductList)
);



// WEBPACK FOOTER //
// ./src/components/ecommerce/SprProductList.js